import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImpersonationService } from '@volo/abp.commercial.ng.ui/config';
import { RoleConstants } from 'src/core/constants/role.constant';
import { UserDto } from 'src/core/models/shared/user.dto';

@Component({
  selector: 'ca-user-detail-toolbar',
  templateUrl: './user-detail-toolbar.component.html',
  styleUrls: ['./user-detail-toolbar.component.scss'],
  standalone: false,
})
export class UserDetailToolbarComponent implements OnInit {
  get impersonateVisibility(): boolean {
    const currentUser = this.configStateService.getDeep('currentUser');

    if (
      this.user?.id == null ||
      this.user.id === '' ||
      this.targetRoleNames == null ||
      currentUser?.impersonatorUserId != null ||
      currentUser?.id === this.user.id
    ) {
      return false;
    }

    const hasRole = (roles: string[], role: string): boolean =>
      roles.some(item => item?.toLowerCase() === role.toLowerCase());

    const currentUserRoles = currentUser?.roles ?? [];
    const currentUserIsAdmin = hasRole(currentUserRoles, RoleConstants.admin);
    const currentUserIsTenantAdmin = hasRole(currentUserRoles, RoleConstants.tenantAdmin);
    const targetUserIsAdmin = hasRole(this.targetRoleNames ?? [], RoleConstants.admin);
    
    return (currentUserIsAdmin || currentUserIsTenantAdmin) && !targetUserIsAdmin;
  }

  @Input()
  user: UserDto;

  @Input()
  targetRoleNames: string[] = null;

  @Input()
  processing = false;

  @Output()
  deleteRequest = new EventEmitter();

  @Output()
  saveRequest: EventEmitter<{
    closeAfterSave: boolean;
  }> = new EventEmitter();

  constructor(
    private impersonationService: ImpersonationService,
    private configStateService: ConfigStateService,
    private toastrService: ToasterService,
    private localizationService: LocalizationService,
  ) {}

  ngOnInit(): void {}

  onClickSaveAndClose(eventArgs: MouseEvent): void {
    this.saveRequest.emit({ closeAfterSave: true });
  }

  onClickSave(eventArgs: MouseEvent): void {
    this.saveRequest.emit({ closeAfterSave: false });
  }

  onClickDelete(eventArgs: MouseEvent): void {
    this.deleteRequest.emit();
  }

  onClickLoginWithUser(eventArgs: MouseEvent) {
    if (!this.impersonateVisibility) {
      return;
    }

    this.impersonateUser();
  }

  private impersonateUser() {
    if (this.user?.id != null) {
      this.impersonationService.impersonateUser(this.user?.id).subscribe(
        x => {},
        response => {
          if (response.error) {
            const message =
              response.error.error === 'invalid_request'
                ? this.localizationService.instant('User::YouCannotImpersonateAdministrator')
                : (response.error.error_description ?? response.error.error);
            this.toastrService.warn(message);
          } else {
            console.error(response);
          }
        },
      );
    }
  }
}
